import WPAPI from 'wpapi'
const wp = new WPAPI({ endpoint: 'http://admin.kk-obi.com/wp-json' });
wp.projects = wp.registerRoute( 'wp/v2', '/stories-api/(?P<id>\\d+)' );

import store from '../../store'
import { getProjectsSuccess } from '../actions/project-actions';
import { getProjectsInCategorySuccess } from '../actions/project-actions';


/**
 * Get project
 */

export function getProjects(link) {
  return wp.projects().slug(link).get().then(response => {
    store.dispatch(getProjectsSuccess(response[0]));
    return response;
  });
}

export function getProjectsInCategory(link) {
 return wp.projects().param('filter[category_name]',link).perPage(50).get().then(response => {
    store.dispatch(getProjectsInCategorySuccess(response));
    return response;
  });
}



/** WEBPACK FOOTER **
 ** ./src/js/api/project-api.js
 **/